import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './css/Admin.css';

const Admin = () => {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ email: '', password: '', role: 'user' });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const API_URL = 'https://newsletter.dizycommerce.com.br/api';

  useEffect(() => {
    // --- LÓGICA DE PROTEÇÃO DE ACESSO ---
    const loggedUser = JSON.parse(sessionStorage.getItem('user'));
    
    if (!loggedUser || loggedUser.role !== 'admin') {
    console.log("Acesso negado: Perfil insuficiente");
    navigate('/lojas');
    return;
  }

    setLoading(false);
    fetchUsers();
  }, [navigate]);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_URL}/users`);
      setUsers(res.data);
    } catch (err) {
      console.error("Erro ao buscar usuários", err);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/users`, newUser);
      alert('✅ Usuário criado com sucesso!');
      setNewUser({ email: '', password: '', role: 'user' });
      fetchUsers();
    } catch (err) {
      const msg = err.response?.data?.error || 'Erro ao criar usuário';
      alert(msg);
    }
  };

  if (loading) return null;

  return (
    <div className="admin-container">
      <header className="admin-header">
        <div className="header-content">
          <button onClick={() => navigate('/lojas')} className="btn-back">← Painel Principal</button>
          <h1>Gestão de Acessos</h1>
        </div>
      </header>

      <main className="admin-main">
        <section className="admin-card">
          <h3>➕ Novo Usuário</h3>
          <form onSubmit={handleCreateUser} className="admin-form">
            <div className="input-group">
              <label>E-mail</label>
              <input 
                type="email" placeholder="exemplo@email.com" required
                value={newUser.email}
                onChange={e => setNewUser({...newUser, email: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Senha</label>
              <input 
                type="password" placeholder="••••••••" required
                value={newUser.password}
                onChange={e => setNewUser({...newUser, password: e.target.value})}
              />
            </div>
            <div className="input-group">
              <label>Nível de Perfil</label>
              <select 
                value={newUser.role}
                onChange={e => setNewUser({...newUser, role: e.target.value})}
              >
                <option value="user">Usuário Comum</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
            <button type="submit" className="btn-create">Criar Conta</button>
          </form>
        </section>

        <section className="admin-card">
          <h3>👥 Usuários Cadastrados</h3>
          <div className="table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>E-mail</th>
                  <th>Perfil</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td>#{u.id}</td>
                    <td className="email-cell">{u.email}</td>
                    <td>
                      <span className={`badge ${u.role}`}>
                        {u.role === 'admin' ? '👑 Admin' : '👤 Usuário'}
                      </span>
                    </td>
                    <td><span className="status-dot"></span> Ativo</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
};



export default Admin;
